import { render, staticRenderFns } from "./ActiveIngredientsDropdown.vue?vue&type=template&id=464bba43&scoped=true"
import script from "./ActiveIngredientsDropdown.vue?vue&type=script&lang=js"
export * from "./ActiveIngredientsDropdown.vue?vue&type=script&lang=js"
import style0 from "./ActiveIngredientsDropdown.vue?vue&type=style&index=0&id=464bba43&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464bba43",
  null
  
)

export default component.exports